export const projectsData = [
  {
    id: 'custom-home-la-ceja',
    cover: '/imgs/project1.jpg',
    gallery: [
      '/imgs/project1.jpg',
      '/imgs/projects/customeHouseBuilding.jpg',
      '/imgs/projects/customhousebuilding2.jpg'
    ],
    title: {
      es: 'Casa Personalizada La Ceja',
      en: 'Custom Home La Ceja'
    },
    description: {
      es: 'Una residencia diseñada a la medida para disfrutar de la vida campestre con detalles contemporáneos y materiales cálidos.',
      en: 'A tailor-made residence that embraces countryside living with contemporary details and warm materials.'
    },
    location: {
      es: 'La Ceja, Antioquia',
      en: 'La Ceja, Antioquia'
    },
    type: {
      es: 'Residencial',
      en: 'Residential'
    },
    year: '2024',
    features: {
      es: [
        'Diseño arquitectónico a medida',
        'Interiores con materiales premium',
        'Espacios exteriores integrados'
      ],
      en: [
        'Tailored architectural design',
        'Premium material interiors',
        'Integrated outdoor living spaces'
      ]
    }
  },
  {
    id: 'custom-home-el-retiro',
    cover: '/imgs/project2.jpg',
    gallery: [
      '/imgs/project2.jpg',
      '/imgs/projects/customhousebuilding2.jpg',
      '/imgs/projects/customeHouseBuilding.jpg'
    ],
    title: {
      es: 'Casa Personalizada El Retiro',
      en: 'Custom Home El Retiro'
    },
    description: {
      es: 'Una casa donde la luz natural, la madera y la piedra crean un ambiente acogedor que se adapta al estilo de vida familiar.',
      en: 'A home where natural light, wood, and stone craft a welcoming environment for family life.'
    },
    location: {
      es: 'El Retiro, Antioquia',
      en: 'El Retiro, Antioquia'
    },
    type: {
      es: 'Residencial',
      en: 'Residential'
    },
    year: '2023',
    features: {
      es: [
        'Planos flexibles para la familia',
        'Ventanas de piso a techo',
        'Terraza con vista panorámica'
      ],
      en: [
        'Flexible family-centric layout',
        'Floor-to-ceiling windows',
        'Panoramic terrace view'
      ]
    }
  },
  {
    id: 'nespresso-office-k2',
    cover: '/imgs/project3.jpg',
    gallery: [
      '/imgs/project3.jpg',
      '/imgs/projects/nesspresoOfice.jpg',
      '/imgs/projects/nesspresoRetail.jpg'
    ],
    title: {
      es: 'Oficina Nespresso K2',
      en: 'Nespresso Office K2'
    },
    description: {
      es: 'Un espacio corporativo que refleja la esencia de la marca con áreas colaborativas y acabados de alta calidad.',
      en: 'A corporate space that mirrors the brand essence through collaborative areas and refined finishes.'
    },
    location: {
      es: 'Medellín, Antioquia',
      en: 'Medellín, Antioquia'
    },
    type: {
      es: 'Comercial',
      en: 'Commercial'
    },
    year: '2022',
    features: {
      es: [
        'Zonas colaborativas flexibles',
        'Iluminación personalizada',
        'Detalles que refuerzan la marca'
      ],
      en: [
        'Flexible collaborative zones',
        'Custom lighting design',
        'Brand reinforcing details'
      ]
    }
  },
  {
    id: 'servid-center',
    cover: '/imgs/project4.jpg',
    gallery: [
      '/imgs/project4.jpg',
      '/imgs/projects/servidEdificio.jpg',
      '/imgs/projects/bathroomRenovation.jpg'
    ],
    title: {
      es: 'Centro de Salud Mental Servid',
      en: 'Servid Mental Health Center'
    },
    description: {
      es: 'Un centro de cuidado diseñado para transmitir serenidad, con espacios terapéuticos y áreas comunes luminosas.',
      en: 'A care center designed to convey calmness with therapeutic rooms and bright community areas.'
    },
    location: {
      es: 'Envigado, Antioquia',
      en: 'Envigado, Antioquia'
    },
    type: {
      es: 'Institucional',
      en: 'Institutional'
    },
    year: '2021',
    features: {
      es: [
        'Espacios terapéuticos insonorizados',
        'Áreas comunes luminosas',
        'Circulaciones fluidas y accesibles'
      ],
      en: [
        'Sound-insulated therapy rooms',
        'Bright communal areas',
        'Accessible, fluid circulation'
      ]
    }
  },
  {
    id: 'custom-home-building',
    cover: '/imgs/projects/customeHouseBuilding.jpg',
    gallery: [
      '/imgs/projects/customeHouseBuilding.jpg',
      '/imgs/project1.jpg',
      '/imgs/project2.jpg'
    ],
    title: {
      es: 'Construcción de Casa Personalizada',
      en: 'Custom Home Building'
    },
    description: {
      es: 'Creamos hogares únicos desde los cimientos hasta los detalles finales, acompañando a cada cliente durante todo el proceso.',
      en: 'We craft unique homes from the ground up, guiding each client through every step of the journey.'
    },
    location: {
      es: 'Santa Fe de Antioquia',
      en: 'Santa Fe de Antioquia'
    },
    type: {
      es: 'Residencial',
      en: 'Residential'
    },
    year: '2020',
    features: {
      es: [
        'Acompañamiento integral',
        'Selección de materiales personalizados',
        'Diseños enfocados en la familia'
      ],
      en: [
        'End-to-end guidance',
        'Personalized material selection',
        'Family-focused layouts'
      ]
    }
  },
  {
    id: 'bathroom-renovation',
    cover: '/imgs/projects/bathroomRenovation.jpg',
    gallery: [
      '/imgs/projects/bathroomRenovation.jpg',
      '/imgs/project3.jpg',
      '/imgs/projects/servidEdificio.jpg'
    ],
    title: {
      es: 'Renovación de Baño',
      en: 'Bathroom Renovation'
    },
    description: {
      es: 'Espacios revitalizados con acabados de lujo, iluminación cálida y soluciones personalizadas de almacenamiento.',
      en: 'Refreshed spaces with luxurious finishes, warm lighting, and tailored storage solutions.'
    },
    location: {
      es: 'Envigado, Antioquia',
      en: 'Envigado, Antioquia'
    },
    type: {
      es: 'Remodelación',
      en: 'Remodeling'
    },
    year: '2019',
    features: {
      es: [
        'Acabados de lujo',
        'Iluminación cálida y funcional',
        'Mobiliario a medida'
      ],
      en: [
        'Luxurious finishes',
        'Warm, functional lighting',
        'Custom-built cabinetry'
      ]
    }
  },
  {
    id: 'nespresso-retail-unit',
    cover: '/imgs/projects/nesspresoRetail.jpg',
    gallery: [
      '/imgs/projects/nesspresoRetail.jpg',
      '/imgs/project3.jpg',
      '/imgs/projects/nesspresoOfice.jpg'
    ],
    title: {
      es: 'Unidad Retail Nespresso',
      en: 'Nespresso Retail Unit'
    },
    description: {
      es: 'Una experiencia de marca inmersiva con exhibiciones modulares y detalles que resaltan la esencia de Nespresso.',
      en: 'An immersive brand experience with modular displays and details that highlight Nespresso’s essence.'
    },
    location: {
      es: 'El Poblado, Medellín',
      en: 'El Poblado, Medellín'
    },
    type: {
      es: 'Retail',
      en: 'Retail'
    },
    year: '2018',
    features: {
      es: [
        'Exhibidores modulares',
        'Paleta de materiales premium',
        'Iluminación dirigida a producto'
      ],
      en: [
        'Modular product displays',
        'Premium material palette',
        'Product-focused lighting'
      ]
    }
  },
  {
    id: 'mental-health-serv',
    cover: '/imgs/projects/servidEdificio.jpg',
    gallery: [
      '/imgs/projects/servidEdificio.jpg',
      '/imgs/project4.jpg',
      '/imgs/projects/bathroomRenovation.jpg'
    ],
    title: {
      es: 'Centro de Bienestar Servid',
      en: 'Servid Wellness Center'
    },
    description: {
      es: 'Una intervención enfocada en el bienestar con áreas de terapia grupal, consultorios privados y espacios comunes vibrantes.',
      en: 'A wellness-focused intervention featuring group therapy areas, private offices, and vibrant communal spaces.'
    },
    location: {
      es: 'Rionegro, Antioquia',
      en: 'Rionegro, Antioquia'
    },
    type: {
      es: 'Institucional',
      en: 'Institutional'
    },
    year: '2017',
    features: {
      es: [
        'Consultorios privados insonorizados',
        'Áreas comunes con vegetación',
        'Circulaciones accesibles'
      ],
      en: [
        'Sound-proof private offices',
        'Green-filled common areas',
        'Accessible circulation paths'
      ]
    }
  }
];
